import React, { useState } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
;
import TopBar from './TopBar';
import useAuth from '../../hooks/useAuth';

interface DashboardLayoutProps {
  children?: ReactNode
}

const useStyles = makeStyles((theme) => ({

  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const DashboardLayout: FC<DashboardLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();

  return (
    <div className={classes.root}>

      {isAuthenticated && (localStorage.getItem('showTopBar') !== "false") && (
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      )}

      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node
};

export default DashboardLayout;
